import React, { useEffect } from "react";
import { ConfigProvider, App as AntdApp } from "antd";
import { Helmet } from "react-helmet";

const RootLayout = ({ children }) => {
  useEffect(() => {
    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      favicon.href = "/cv_icon2.png";
    } else {
      const newFavicon = document.createElement("link");
      newFavicon.rel = "icon";
      newFavicon.href = "/cv_icon2.png";
      document.head.appendChild(newFavicon);
    }
  }, []);

  return (
    <ConfigProvider>
      <AntdApp>
        <Helmet>
          <title>CV Analyzer</title>
        </Helmet>
        <div className="antialiased font-sans">{children}</div>
      </AntdApp>
    </ConfigProvider>
  );
};

export default RootLayout;
